import React, { createContext, useContext, useEffect, useState } from 'react';

// 1. Krijo kontekstin
const AuthContext = createContext();

// 2. Hook për qasje të lehtë
export const useAuth = () => useContext(AuthContext);

// 3. Provider

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [roli, setRoli] = useState(null);
  const [token, setToken] = useState(null);
  const [location, setLocation] = useState(null);
  const [isPrincipal, setIsPrincipal] = useState(false);
  const [loading, setLoading] = useState(true); // Shto loading

  useEffect(() => {
    const savedToken = localStorage.getItem('token');
    const savedEmri = localStorage.getItem('emri');
    const savedRoli = localStorage.getItem('roli');
    const savedLocation = localStorage.getItem('lokacion_id');
    const savedIsPrincipal = localStorage.getItem('is_principal') === 'true';

    if (savedToken && savedEmri && savedRoli) {
      setToken(savedToken);
      setUser(savedEmri);
      setRoli(savedRoli);
      setLocation(savedLocation);
      setIsPrincipal(savedIsPrincipal);
    }

    setLoading(false); // Tregon se ngarkimi ka përfunduar
  }, []);

  const login = (token, emri, roli, lokacion_id, is_principal = false) => {
    localStorage.setItem('token', token);
    localStorage.setItem('emri', emri);
    localStorage.setItem('roli', roli);
    localStorage.setItem('lokacion_id', lokacion_id);
    localStorage.setItem('is_principal', is_principal ? 'true' : 'false');

    setToken(token);
    setUser(emri);
    setRoli(roli);
    setLocation(lokacion_id);
    setIsPrincipal(is_principal);
  };

  const logout = () => {
    localStorage.clear();
    setToken(null);
    setUser(null);
    setRoli(null);
    setLocation(null);
    setIsPrincipal(false);
    window.location.href = 'login';
  };

  return (
    <AuthContext.Provider value={{ 
      user, roli, token, lokacion_id: location, 
      login, logout, loading, isPrincipal: isPrincipal 
    }}>
      {children}
    </AuthContext.Provider>
  );
};
